import React, { useEffect, useState } from "react";
import { Form, Input, Modal, message, theme, Row, Col } from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function AddSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    try {
      const data = await form.validateFields();

      if (target?.id) {
        await PATCH(`${URL_SETTING.PRODUCT}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.PRODUCT, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขสินค้าสกิม" : "เพิ่มสินค้าสกิม"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="ชื่อสินค้า"
              name="name"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="กรอกชื่อสินค้า" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="ชื่อย่อ"
              name="short_name"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="กรอกชื่อย่อ" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="น้ำหนัก (kg)/ก้อน"
              name="weight"
            >
              <Input placeholder="กรอกชื่อย่อ" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="type"
          initialValue={"skim"}
          style={{ display: "none" }}
        >
          <Input value="skim" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
